import React from 'react'
import { Grid, Typography, Card, CardContent } from '@mui/material'

const AboutYouSpeakScreen = () => {
  return (
    <Grid className='container' container direction='column' spacing={1} style={{ margin: '0', width: '100%' }}>
      <Grid item>
        <Typography variant='h5' style={{ textTransform: 'uppercase' }}>Giới thiệu</Typography>
      </Grid>

      <Grid item>
        <Card>
          <CardContent>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <Typography variant='body1'>
                  YouSpeak là một nền tảng kết nối các giáo viên dạy tiếng Anh và những người đang có nhu cầu học tiếng Anh giao tiếp, ôn thi TOIEC,  TOEFL, IELTS…
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant='body1'>
                  Người học có thể chọn giáo viên, chương trình học, giờ học và học phí phù hợp với nhu cầu của mình.
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant='body1'>Giáo viên có thể tự do đặt chương trình dạy, giờ dạy và học phí cho mỗi bài học.</Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default AboutYouSpeakScreen